import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"check\"><path d=\"M13.013 24.213L4.693 16l2.24-2.24 5.973 5.973L24.959 7.786l2.24 2.24-14.187 14.187z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol